import MarkdownRenderer from './components/MarkdownRenderer';
import patternsContent from '@/content/Patterns.md?raw';

export default function Patterns() {
  return (
    <div className="px-4 md:px-6 py-4 md:py-6">
      {/* ─── Page Header ─── */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-primary-500/10 flex items-center justify-center">
            <i className="ri-book-2-line text-primary-400 text-lg"></i>
          </div>
          <div>
            <h1 className="text-lg font-heading font-bold text-foreground-950">Patterns</h1>
            <p className="text-xs text-foreground-500">
              Trading patterns reference — full documentation
            </p>
          </div>
        </div>

        <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-accent-500/10 text-accent-400 border border-accent-500/20 w-fit">
          <i className="ri-file-text-line"></i>
          Reference
        </div>
      </div>

      {/* ─── Content ─── */}
      <div className="bg-background-100 rounded-xl border border-background-200/70 p-5 md:p-8">
        <MarkdownRenderer content={patternsContent} />
      </div>
    </div>
  );
}